module.exports = __webpack_public_path__ + "static/img/12.82e789b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/about/images/12.jpg
// module id = KL3j
// module chunks = 21